import React from 'react'
import { CenterPanel } from '../routesLayout'
import { EnvironmentTitle } from 'view/shared/heroPanel'
import { Locale, Translation } from 'locale'
import { AxeGridContainer } from './AxeGrid'
import { AxeActor, AxeSubscriptionIdentifier, EntityTypeEnum } from 'api'
import { AxeActions } from 'api/AxeAction'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createResponderAxeDetailsSelector } from 'selectors/axeSelectors'
import { createEntitySubscriptionSelector } from 'selectors/selectionSelectors'
import { AxeBoardContentContainer } from './axeBoard.styled'
import { GridId } from 'store/grid'
import { partial } from 'lodash'
import { ConnectedHeroPanel } from 'view/shared/heroPanel/ConnectedHeroPanel'

export const AxeGridResponder = connect(
  createStructuredSelector({
    viewAs: () => AxeActor.RESPONDER,
    gridId: () => GridId.AxeGridResponder,
    axeDetails: createResponderAxeDetailsSelector(),
    subscriptionDetail: createEntitySubscriptionSelector(
      () => EntityTypeEnum.AXE,
      () => AxeSubscriptionIdentifier.AXE_TODAY_RESPONDER
    )
  }),
  {
    handlePageSubscribe: partial(AxeActions.pageSubscribe, AxeSubscriptionIdentifier.AXE_TODAY_RESPONDER)
  }
)(AxeGridContainer)

export const AxeBoardResponder: React.FC = () => (
  <CenterPanel>
    <ConnectedHeroPanel tearoutUrl="/tearout/axeBoardResponder">
      <EnvironmentTitle>{Locale.translate(Translation.TC_HERO_INCOMING_AXE)}</EnvironmentTitle>
    </ConnectedHeroPanel>
    <AxeBoardContentContainer>
      <AxeGridResponder />
    </AxeBoardContentContainer>
  </CenterPanel>
)
